import { CommonMessage } from '@frontend/lang';
import { LuShoppingCart } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { LeafCategoryView } from '../browse-products-by-categories/leaf-category-view/leaf-category-view.component';
import { useSelectAttributes } from './select-attributes.controller';

export const SelectAttributes = () => {
    const viewProps = useSelectAttributes();

    if (!viewProps.category) {
        return (
            <WizardScreenContainer
                footer={{ onBack: viewProps.navigateBack }}
                header={{ title: CommonMessage.WIZARD.SHOP.DEFAULT, onBack: viewProps.navigateBack }}>
                <div className='flex h-full w-full items-center justify-center py-12'>
                    <p>
                        <FormattedMessage
                            id='wizard.select-attributes.category-not-found'
                            defaultMessage='No category selected'
                            description='Error message when the product attribute screen is opened without a category'
                        />
                    </p>
                </div>
            </WizardScreenContainer>
        );
    }

    return (
        <WizardScreenContainer
            footer={{
                onBack: viewProps.navigateBack,
                onSubmit: viewProps.confirmProductSelection,
                submitLabel: viewProps.isOrderFallback ? (
                    CommonMessage.BUTTONS.CHOOSE_DELIVERY_LOCATION
                ) : (
                    <FormattedMessage
                        id='wizard.select-attributes.continue'
                        defaultMessage='Choose product'
                        description='Submit button on the kiosk product attribute screen'
                    />
                ),
                submitDisabled:
                    !viewProps.selectedProduct || viewProps.isCheckingOrderPermission || (viewProps.isOrderFallback && !viewProps.hasOrderFallbackStep)
            }}
            footerNotice={
                viewProps.isOrderFallback ? (
                    <div
                        role='status'
                        className='bg-status-warning text-background-default mx-auto flex w-fit items-center gap-2 rounded-full px-4 py-2 text-sm font-medium shadow-sm'>
                        <LuShoppingCart className='size-4 shrink-0' />
                        <FormattedMessage
                            id='kiosk.wizard.select-attributes.order-fallback.status'
                            description='Persistent status shown when a selected consumable product is unavailable at the current distriSPOT and will be ordered for delivery'
                            defaultMessage='Not available at this distriSPOT · Order for delivery'
                        />
                    </div>
                ) : undefined
            }
            header={{ title: CommonMessage.WIZARD.SHOP.DEFAULT, onBack: viewProps.navigateBack }}>
            <LeafCategoryView
                category={viewProps.category}
                onProductSelected={viewProps.handleProductSelected}
            />
        </WizardScreenContainer>
    );
};
